import * as $ from 'jquery';
import 'bootstrap';
import 'MagnificPopup';
import * as Cookies from 'js-cookie';
import {headerContent} from './c002';
import {bookingFormCommon} from './c005-bookingform-common';

export class loginForm {
	private $loginError:Array<string> = [];
	private bcommon: any = new bookingFormCommon();

	$scope: any = $('#login-container');
	$scopeMid: any = $('#mab-header #mob-login--container');
	$scopeMob: any = $('#mab-bookingnav #bookingNav #mob-login--container');

	$loginContainer: any = this.$scopeMob;
	$enrich: any = $('.enrich-login, .enrich-login--overlay');
	$ibeFormContainer:any = $('.ibe-form--container');
	$ibeNav: any = $('#bookingNav');

	$loginErrorValidation: any = $('.login-error---validation');
	$loginValidator   : any      = this.$scope.find('.login-validator');
	$midLoginValidator: any      = this.$scopeMid.find('.login-validator');
	$mobLoginValidator: any      = this.$scopeMob.find('#mobile-login--validator');

	// Desktop Screen
	$loginMHNo: any            = $('.login-MH--no');
	$loginMHPassword: any      = $('.login-MH--password');

	// Mid Screen
	$midScrLoginMHNo: any       = $('.midScrLogin-MH--no');
	$midScrLoginMHPassword: any = $('.midScrLogin-MH--password');

	// Mobile Screen
	$mobLoginMHNo: any       = $('.mobLogin-MH--no');
	$mobLoginMHPassword: any = $('.mobLogin-MH--password');

	$loginCookieName: string  = 'MAB-Enrich-LoginID';

	/**
	 * login nav ibe behavior
	 */
	nav(): void {
		let _self = this;
		let bcommon = _self.bcommon;
		let $mabHeader:any = $('#mab-header');
		let $mholidaysbookFlight: any = $('#mholiday-ibe--container');
		let $mholidaysbookFlight_mob: any = $('#mobile-mholidays--container');
		let $bookFlight: any = $('#book-flight--container');
		let $checkIn: any = $('#check-in--container');
		let $viewBooking: any = $('#view-booking--container');
		let $flightStatus: any = $('#flight-status--container');
		let $mhStay: any = $('#ibe-stay--container');
		let $mhUpgrade: any = $('#mhupgrade-in--container');

		let $bookFlightMob: any = $('#mobile-bookflight--container');
		let $checkInMob: any = $('#mob-checkin--container');
		let $viewBookingMob: any = $('#mob-viewbooking--container');
		let $flightStatusMob: any = $('#mob-flightstatus--container');
		let $mhStayMob: any = $('#mob-stay--container');
		let $mhUpgradeMob: any = $('#mob-mhupgrade--container');
		let $flightupgradeMob: any 	 = $('#mob-flightupgrade--container');
		let $ibeNavList: any = $('#bookingNav li');
		let $mobIbeNav: any = $('#mab-header.mobile #slide-nav');
		let $bannerHeight: any = $('.img-holder').height();

		let $errorValidationGen:any = $('.login-error---validation');
		let $bookingFormTitle:any   = $('.booking-form--title');
		let $inputValidator:any     = $('.form-validate input');
		let $loggedInMenumob:any    = $('#mobenrich-login--container');
		let $loggedInMenu_mob:any    = $('#mob_enrich-login--container');
		let $loggedInMenu:any    = $('#logged-in-user-menu');
		let $mobLoggedInMenu:any = $('#mob-logged-in-user-menu');
		let $loggedInMenumh:any    = $('#loggedmh-in-user-menu');

		let loggedIn = _self.isUserLoggedIn();

		if (loggedIn) {
			_self.$ibeNav.find('.login-nav .login-success').addClass('logged-in');
			_self.$ibeNav.find('.login-nav .login').addClass('logged-in');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .login-success').addClass('logged-in');
				$('.enrich-revamp .login').addClass('logged-in');
				//Enrich revamp toggle menu
				$('.enrich-revamp .login-success.logged-in').click((e:any) =>{
					e.stopPropagation();
					$('.enrich-header #mab-header #logged-in-user-menu').toggleClass("hidden");
				})
			}
			$mobIbeNav.find('.enrich-login').addClass('logged-in');
			$mobIbeNav.find('.enrich-signup').addClass('logged-in');
			$mobIbeNav.find('.enrich-login--success').addClass('logged-in');
			// $mobIbeNav.find('.enrich-loggedin').removeClass('hidden');
			$('.login ').hide();
			$('.login-success').show();
		} else {
			_self.$ibeNav.find('.login-nav .login-success').removeClass('logged-in');
			_self.$ibeNav.find('.login-nav .login').removeClass('logged-in');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .login-success').removeClass('logged-in');
				$('.enrich-revamp .login').removeClass('logged-in');
				$('.login ').show();
			$('.login-success').hide();
			}
			$mobIbeNav.find('.enrich-login').removeClass('logged-in');
			$mobIbeNav.find('.enrich-signup').removeClass('logged-in');
			$mobIbeNav.find('.enrich-login--success').removeClass('logged-in');
			$mobIbeNav.find('.enrich-loggedin').addClass('hidden');
		}

		$(document).on('click', () => {

			$('#loggedmh-in-user-menu').addClass('hidden');
			$('#mobmh-login--container').addClass('hidden');
			$('#logged-in-user-menu').addClass('hidden');
			$('#mobenrich-login--container').addClass('hidden');
			$('#mob_mh-login--container').addClass('hidden');
			$('#mob_enrich-login--container').addClass('hidden');
			mobIsOpen = false;
		});
		
		// IBE Navigation show/hide Check in container
		$('.login-nav .login').click((e:any) =>{
			e.stopPropagation();
			// $('#loggedmh-in-user-menu').removeClass('hidden');
			// desktop stuff
			if ($('.ibe-refresh').length == 0) {
				_self.$ibeNav.find('li').removeClass('selected');
				_self.$ibeNav.find('.login').parent().addClass('selected');
				//_self.$scope.show();
				$bookFlight.hide();
				$checkIn.hide();
				$viewBooking.hide();
				$flightStatus.hide();
				$mhStay.hide();
				$mhUpgrade.hide();
				$mholidaysbookFlight.hide();
				$mholidaysbookFlight_mob.hide();
			}
			// mobile stuff
			_self.$scopeMob.hide();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$flightupgradeMob.hide();
			// ibe stuff
			$errorValidationGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');
			$loggedInMenumh.toggleClass('hidden');
			$loggedInMenumh.find('.submenu').css("display", "none");
			$loggedInMenumh.find('li').removeClass('open');
			
			 $('#loggedmh-in-user-menu .link[data-pre-loginaccordian-id]').get(0).click();
			if (!loggedIn) {
				//_self.$scope.show();
				_self.$scopeMob.hide();

				if (_self.$loginMHNo.val() != '') {
					_self.$loginMHNo.addClass('input-focused');
					_self.$loginMHNo.parent().find('.booking-form--title').addClass('input-filled');
				} else {
					_self.$loginMHNo.removeClass('input-focused');
					_self.$loginMHNo.parent().find('.booking-form--title').removeClass('input-filled');
				}

				if (_self.$loginMHPassword.val() != '') {
					_self.$loginMHPassword.addClass('input-focused');
					_self.$loginMHPassword.parent().find('.booking-form--title').addClass('input-filled');
				} else {
					_self.$loginMHPassword.removeClass('input-focused');
					_self.$loginMHPassword.parent().find('.booking-form--title').removeClass('input-filled');
				}
			}
			  // initial 
			  $("li .link:not(:first-of-type)").css("display", "none");
			  //initial
			  $("li .submenu:first-of-type").addClass("open");
		});

		$('#mab-header.mobile .enrich-login').click((e:any) =>{
			e.stopPropagation();
			$mholidaysbookFlight_mob.hide();
			$('#mobmh-login--container').toggleClass('hidden');
			$('#mob_mh-login--container').toggleClass('hidden');
			$('#mobmh-login--container').find('.submenu').css("display", "none");
			$('#mobmh-login--container').find('li').removeClass('open');
			$('#mobmh-login--container .link[data-pre-loginaccordian-id]').get(0).click();
		});		

		$('#logged-in-user-menu .enrich-logins').click((e:any) =>{
			e.stopPropagation();

			$('#logged-in-user-menu .menu-item').toggleClass('hidden');	
			if($('#logged-in-user-menu .menu-item').hasClass('hidden'))
			{
				$loggedInMenu.find('.enrich-logins .fa-angle-down').removeClass('enrich-collapse')
			}
			else
			{
				$loggedInMenu.find('.enrich-logins .fa-angle-down').addClass('enrich-collapse')
			}
	
		});

		$('#mobenrich-login--container .enrich-logins').click((e:any) =>{
			e.stopPropagation();
			$('#mobenrich-login--container .menu-item').toggleClass('hidden');		
			if($('#mobenrich-login--container .menu-item').hasClass('hidden'))
			{
				$loggedInMenumob.find('.enrich-logins .fa-angle-down').removeClass('enrich-collapse')
			}
			else
			{
				$loggedInMenumob.find('.enrich-logins .fa-angle-down').addClass('enrich-collapse')
			}		
		});
		$('#mob_enrich-login--container .enrich-logins').click((e:any) =>{
			e.stopPropagation();
			$('#mob_enrich-login--container .menu-item').toggleClass('hidden');		
			if($('#mob_enrich-login--container .menu-item').hasClass('hidden'))
			{
				$loggedInMenu_mob.find('.enrich-logins .fa-angle-down').removeClass('enrich-collapse')
			}
			else
			{
				$loggedInMenu_mob.find('.enrich-logins .fa-angle-down').addClass('enrich-collapse')
			}		
		});
		// toggle desktop enrich login menu
		$('.login-nav .login-success').click((e:any) =>{
			e.stopPropagation();
			// $('#logged-in-user-menu').removeClass('hidden');
			_self.$ibeNav.find('li').removeClass('selected');
			_self.$ibeNav.find('.login-nav .login-success').parent().addClass('selected');

			_self.$scope.hide();
			$bookFlight.hide();
			$checkIn.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$mholidaysbookFlight.hide();
			$mholidaysbookFlight_mob.hide();
			_self.$scopeMob.hide();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();

			$errorValidationGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');

			$(this).addClass('active');
			$loggedInMenu.toggleClass('hidden');
			if(!$('#logged-in-user-menu .menu-item').hasClass('hidden'))
			{
				$('#logged-in-user-menu .menu-item').addClass('hidden');
				$loggedInMenu.find('.enrich-logins .fa-angle-down').removeClass('enrich-collapse');
			}
			$loggedInMenu.find('.submenu').css("display", "none");
			$loggedInMenu.find('li').removeClass('open');
			//open desktop post login menu from configuration 
			$('#logged-in-user-menu .link[data-post-loginaccordian-id]').get(0).click();
		});

		let mobIsOpen:boolean = false;

		if (loggedIn) {
			// $mobLoggedInMenu.parent().css({
			// 	'display': 'block',
			// 	'border': 'none',
			// 	'padding': '0',
			// 	'width': 'calc(100% + 30px)',
			// 	'left': '-15px'
			// });

			$mobLoggedInMenu.css({
				'top': '0',
				'width': '100%',
				'position': 'absolute'
			});
		}

		// toggle mobile enrich login menu
		$mobIbeNav.find('.enrich-login--success').click(function(e:any) {
			e.preventDefault();
			e.stopPropagation();
			if(!$('#mobenrich-login--container .menu-item').hasClass('hidden'))
			{
				$('#mobenrich-login--container .menu-item').addClass('hidden')
				$loggedInMenumob.find('.enrich-logins .fa-angle-down').removeClass('enrich-collapse');
			}
			if(!$('#mob_enrich-login--container .menu-item').hasClass('hidden'))
			{
				$('#mob_enrich-login--container .menu-item').addClass('hidden')
				$loggedInMenu_mob.find('.enrich-logins .fa-angle-down').removeClass('enrich-collapse');
			}
			if (!mobIsOpen) {
				$ibeNavList.removeClass('selected');

				_self.$scopeMob.hide();
				$bookFlightMob.hide();
				$checkInMob.hide();
				$viewBookingMob.hide();
				$flightStatusMob.hide();
				$mhStayMob.hide();
				$mhUpgradeMob.hide();
				$mholidaysbookFlight_mob.hide();
				$errorValidationGen.hide();
				$bookingFormTitle.removeClass('has-error');
				$inputValidator.removeClass('has-error');

				$(this).addClass('active');
				$mobLoggedInMenu.css('display', '');
				$('#mobenrich-login--container').removeClass('hidden');
				$('#mob_enrich-login--container').removeClass('hidden');
				mobIsOpen = true;
			} else {
				$(this).removeClass('active');
				$mobLoggedInMenu.css('display', 'none');
				$('#mobenrich-login--container').addClass('hidden');
				$('#mob_enrich-login--container').addClass('hidden');
				mobIsOpen = false;
			}
			//open mobile post login menu from configuration
			$('#mobenrich-login--container .link[data-post-loginaccordian-id]').get(0).click();
		});

		// temporary workaround 13/02/18
		// - remove midscreen login form (not in use)
		// - duplicate ids are breaking the mob login form
		_self.$scopeMid.find('form').remove();

		// MESU-285: Rework mobile enrich login form
		// - use magnific popup instead of custom overlay
		let mobSidebarLoginLink:any = $('#mab-header.mobile .enrich-login, .mab-nav--overlay li a.mobile-enrich-login');
		/*if (!loggedIn) {
			mobSidebarLoginLink.each(function() {
				$(this).magnificPopup({
					items: {
						src: _self.$scopeMob[0],
						type: 'inline'
					},
					preloader: false,
					callbacks: {
						open: function() {
				    	// show login form on opening popup
				    	_self.$scopeMob.css({
				    		'display': 'block'
				    	});
				    },
				    close: function() {
				    	// hide login form on closing popup
				    	_self.$scopeMob.css({
				    		'display': ''
				    	});
				    }
				  }
				});
			});
		}*/

		mobSidebarLoginLink.click(function() {
			$ibeNavList.removeClass('selected');
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();

			// open mobile ibe
			// _self.$scopeMob.show();

			bcommon.scrollToTopIBE();

			if (!loggedIn) {
				if (_self.$mobLoginMHNo.val() != '') {
					_self.$mobLoginMHNo.addClass('input-focused');
					_self.$mobLoginMHNo.parent().find('.booking-form--title').addClass('input-filled');
				} else {
					_self.$mobLoginMHNo.removeClass('input-focused');
					_self.$mobLoginMHNo.parent().find('.booking-form--title').removeClass('input-filled');
				}

				if (_self.$mobLoginMHPassword.val() != '') {
					_self.$mobLoginMHPassword.addClass('input-focused');
					_self.$mobLoginMHPassword.parent().find('.booking-form--title').addClass('input-filled');
				} else {
					_self.$mobLoginMHPassword.removeClass('input-focused');
					_self.$mobLoginMHPassword.parent().find('.booking-form--title').removeClass('input-filled');
				}
			}
		});

		if (loggedIn) {
			let sidebarLink = $('a.mobile-enrich-login')
			sidebarLink.off();
			sidebarLink.html('<i class="fa fa-sign-out" aria-hidden="true"></i>'+sidebarLink.attr('data-logout-text'));
			sidebarLink.on('click', (e:any) => {
				e.preventDefault();
				e.stopPropagation();
				_self.logOutUser();
			});
		}
	}

	/**
	 * Load login component for mobile environment
	 * @dominic (25/01/2018):
	 * what does this function do?
	 * is it supposed to add input classes on the login form on load?
	 * it should not be running on click
	 */
	loginContainer(): void {
		let _self = this;
		let $mobLoginMHNo: any = $('.mobLogin-MH--no');
		let $mobLoginMHPassword: any = $('.mobLogin-MH--password');

		/*_self.$enrich.on('click', () =>{
				_self.$loginContainer.fadeIn(100);
				if ($mobLoginMHNo.val() != '') {
					$mobLoginMHNo.addClass('input-focused');
					$mobLoginMHNo.parent().find('.booking-form--title').addClass('input-filled');
				} else {
					$mobLoginMHNo.removeClass('input-focused');
					$mobLoginMHNo.parent().find('.booking-form--title').removeClass('input-filled');
				}
				if ($mobLoginMHPassword.val() != '') {
					$mobLoginMHPassword.addClass('input-focused');
					$mobLoginMHPassword.parent().find('.booking-form--title').addClass('input-filled');
				} else {
					$mobLoginMHPassword.removeClass('input-focused');
					$mobLoginMHPassword.parent().find('.booking-form--title').removeClass('input-filled');
				}
		});*/
	}

	/**
	 * populate login cookie if present on load
	 * to all login forms
	 */
	initLoginCookie(): void {
    let _self = this;
    let $iberedemptionLogin:any = $('[data-ibe-redemption--login-id]').eq(0);
		let	$loginPageMHNo : any = $('.login-MHnumber');

    // populate cookie value and apply filled classes
    function populateCookieValue($el:any, $cookieValue:any) {
        $el.val($cookieValue);
        $el.addClass('input-focused');
        $el.parent().find('label').addClass('input-filled');
    }

    // if cookie is present, add value to input
    if (Cookies.get(_self.$loginCookieName)) {
        let $cookieValue:any = Cookies.get(_self.$loginCookieName);

        populateCookieValue(_self.$loginMHNo, $cookieValue); // desktop
        populateCookieValue(_self.$midScrLoginMHNo, $cookieValue); // midscreen
        populateCookieValue(_self.$mobLoginMHNo, $cookieValue); // mobile
        populateCookieValue($loginPageMHNo, $cookieValue); // login page
        populateCookieValue($iberedemptionLogin, $cookieValue); // booking redemption
    }
      return;
	}

	/**
	 * consolidated init validation on all login forms
	 * - desktop
	 * - mobile
	 * - midscreen (not currently in use)
	 */
	loginEnrich(): void {
		let _self = this;

		// Big Screen Validation
		_self.desktopValidation();
		// Mobile Screen Validation
		_self.mobileValidation();
		// Mid Screen Validation
		// _self.midScreenValidation();
	}

	/**
	 * validation for login ibe desktop form
	 */
	desktopValidation(): void {
		let _self = this;
		let $loginSubmitBtn: any = _self.$scope.find('.enRichLoginSubmit');

		$loginSubmitBtn.click((evt:any) => {
			evt.preventDefault();

			_self.$loginError = [];
			_self.$loginErrorValidation.show();
			if ((_self.$loginMHNo.val() != '') && (_self.$loginMHPassword.val() != '')) {
				 _self.$loginErrorValidation.hide();
			}

			if (_self.$loginMHNo.val() == '') {
				let $loginMHNoValidate:any = _self.$loginMHNo.attr('data-loginmhno');
				_self.$loginError.push('<strong>'+_self.$loginMHNo.parent().find('label').text()+':</strong> '+$loginMHNoValidate);
				_self.$loginMHNo.addClass('has-error');
				_self.$loginMHNo.parent().find('.booking-form--title').addClass('has-error');
			} else {
				_self.$loginMHNo.removeClass('has-error');
				_self.$loginMHNo.parent().find('.booking-form--title').removeClass('has-error');
			}

			if (_self.$loginMHPassword.val() == '') {
				let $loginMHPasswordValidate:any = _self.$loginMHPassword.attr('data-loginmhpassword');
				_self.$loginError.push('<strong>'+_self.$loginMHPassword.parent().find('label').text()+':</strong> '+$loginMHPasswordValidate);
				_self.$loginMHPassword.addClass('has-error');
				_self.$loginMHPassword.parent().find('.booking-form--title').addClass('has-error');
			} else {
				_self.$loginMHPassword.removeClass('has-error');
				_self.$loginMHPassword.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = _self.$loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=_self.$loginError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + _self.$loginError[i] + '</li>');
			}

			if (_self.$loginMHNo.val() != '' && _self.$loginMHPassword.val() != '') {
				if ($('#ibe-login--enrich').is(':checked')) {
					let $cookieIdValue: any = _self.$loginMHNo.val();
					Cookies.set(_self.$loginCookieName, $cookieIdValue);
				} else {
					Cookies.set(_self.$loginCookieName, '');
				}
				_self.bcommon.preloader();
				console.log('Success');
				_self.$loginError = [];
				console.log('Success');
				var data = {
					'userId':		_self.$loginMHNo.val(),
					'password':	_self.$loginMHPassword.val()
				};

				$.ajax({
					type: 'POST',
					url:'/bin/services/new/authuser',
					data: data,
					success: function(msg:string) {
						_self.redirectUser(msg);
            	//_self.$loginErrorValidation.show();
            	var json = JSON.parse(msg);
            	var responseCode = json.responseCode;
            	if (responseCode == "OK") {
            		console.log("success");
            		var loginSuccess = $("#exceptionmsg").attr("data-loginsuccess");

            		var d = new Date();
            		d.setTime(d.getTime() + (30 * 60 * 1000));
            		var expires = "expires="+d.toUTCString();

            	//	document.cookie="jade="+json.cookieValue+";"+expires+";path=/";
					document.cookie="phantom="+json.phantomCookieValue+";"+expires+";path=/";
					document.cookie = "userName=" + JSON.parse(json.phantomCookieValue).userName +";"+expires+";path=/";
					document.cookie = "milesCount=" + JSON.parse(json.phantomCookieValue).milesCount + ";"+expires+";path=/";
					document.cookie = "flyerID=" + JSON.parse(json.phantomCookieValue).flyerID + ";"+expires+";path=/"; 
					document.cookie = "memberStatus=" + JSON.parse(json.phantomCookieValue).memberStatus + ";"+expires+";path=/"; 
            		// _self.bcommon.preloaderClose();
            		_self.$ibeFormContainer.hide();
            		_self.$ibeNav.find('li').removeClass('selected');
            		window.location.href = loginSuccess;

              	// Redirect to the configured page from here.
              } else if(responseCode == "PW") {
              	_self.$loginErrorValidation.show();
              	_self.$loginMHPassword.addClass('has-error');
              	_self.$loginMHPassword.parent().find('.booking-form--title').addClass('has-error');
              	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 4 more attempt(s)";
              	_self.$loginError.push($checkInBookRefNoLastnameValidate);
              } else if(responseCode == "LC") {
              	_self.$loginErrorValidation.show();
              	var locked  = $("#exceptionmsg").attr("data-locked");
              	_self.$loginErrorValidation.show();
              	_self.$loginMHNo.addClass('has-error');
              	_self.$loginMHNo.parent().find('.booking-form--title').addClass('has-error');

              	_self.$loginError.push(locked);

              } else if(responseCode == "NA") {
              	_self.$loginErrorValidation.show();
              	_self.$loginMHNo.addClass('has-error');
              	_self.$loginMHNo.parent().find('.booking-form--title').addClass('has-error');
              	var $checkInBookRefNoValidate = "Invalid login";
              	_self.$loginError.push($checkInBookRefNoValidate);
              } else if(responseCode == "W2") {
              	_self.$loginErrorValidation.show();
              	_self.$loginMHPassword.addClass('has-error');
              	_self.$loginMHPassword.parent().find('.booking-form--title').addClass('has-error');
              	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 3 more attempt(s)";
              	_self.$loginError.push($checkInBookRefNoLastnameValidate);
              } else if(responseCode == "W3") {
              	_self.$loginErrorValidation.show();
              	_self.$loginMHPassword.addClass('has-error');
              	_self.$loginMHPassword.parent().find('.booking-form--title').addClass('has-error');
              	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 2 more attempt(s)";
              	_self.$loginError.push($checkInBookRefNoLastnameValidate);
              } else if(responseCode == "W4") {
              	_self.$loginErrorValidation.show();
              	_self.$loginMHPassword.addClass('has-error');
              	_self.$loginMHPassword.parent().find('.booking-form--title').addClass('has-error');
              	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 1 more attempt(s)";
              	_self.$loginError.push($checkInBookRefNoLastnameValidate);
              } else if(responseCode == "ST") {
              	_self.$loginErrorValidation.show();
              	_self.$loginMHPassword.addClass('has-error');
              	_self.$loginMHPassword.parent().find('.booking-form--title').addClass('has-error');
              	var $checkInBookRefNoLastnameValidate = "This is invalid/inactive account. Kindly contact call center for further information";
              	_self.$loginError.push($checkInBookRefNoLastnameValidate);
              }else if (responseCode == "TO") {
				_self.$loginErrorValidation.show();
				_self.$loginError.push("Sorry, we are unable to process your request at this time. please try again later.");
			}
              var $validationContainer = _self.$loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
              var $validationMessagelist = $validationContainer;
              for (var i = 0, len = _self.$loginError.length; i < len; i++) {
              	$validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
              }
            	if (responseCode !== "OK") {
	              _self.bcommon.preloaderClose();
	            }
            },
            error: function(error:any) {
							console.log('Fail submit');
            	_self.bcommon.preloaderClose();
            	// _self.$ibeFormContainer.hide();
            	_self.$ibeNav.find('li').removeClass('selected');
            }
          });

			} else {
				console.log('Fail');
			}
		});
	}

	/**
	 * validation for mobile login popup overlay form
	 */
	mobileValidation(): void {
		let _self = this;
		let $mobLoginSubmitBtn: any = _self.$scopeMob.find('.mobEnRichLoginSubmit');

		$mobLoginSubmitBtn.click((evt:any) => {

			evt.preventDefault();
			_self.$loginError = [];
			_self.$loginErrorValidation.show();
			if ((_self.$mobLoginMHNo.val() !== '') && (_self.$mobLoginMHPassword.val() !== '')) {
				 _self.$loginErrorValidation.hide();
			}

			if (_self.$mobLoginMHNo.val() == '') {
				let $mobLoginMHNoValidate:any = _self.$mobLoginMHNo.attr('data-loginmhno');
				_self.$loginError.push('<strong>'+_self.$mobLoginMHNo.parent().find('label').text()+':</strong> '+$mobLoginMHNoValidate);
				_self.$mobLoginMHNo.addClass('has-error');
				_self.$mobLoginMHNo.parent().find('.booking-form--title').addClass('has-error');
			} else {
				_self.$mobLoginMHNo.removeClass('has-error');
				_self.$mobLoginMHNo.parent().find('.booking-form--title').removeClass('has-error');
			}

			if (_self.$mobLoginMHPassword.val() == '') {
				let $$mobLoginMHPasswordValidate:any = _self.$mobLoginMHPassword.attr('data-loginmhpassword');
				_self.$loginError.push('<strong>'+_self.$mobLoginMHPassword.parent().find('label').text()+':</strong> '+$$mobLoginMHPasswordValidate);
				_self.$mobLoginMHPassword.addClass('has-error');
				_self.$mobLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
			} else {
				_self.$mobLoginMHPassword.removeClass('has-error');
				_self.$mobLoginMHPassword.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = _self.$mobLoginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=_self.$loginError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + _self.$loginError[i] + '</li>');
			}

			if (_self.$mobLoginMHNo.val() != '' && _self.$mobLoginMHPassword.val() != '') {
				if ($('#ibe-moblogin--enrich').is(':checked')) {
					let $cookieIdValue: any = _self.$mobLoginMHNo.val();
					Cookies.set(_self.$loginCookieName, $cookieIdValue);
				} else {
					Cookies.set(_self.$loginCookieName, '');
				}
				_self.bcommon.preloader();
				_self.$loginError = [];
				console.log('Success');
				var data = {
					'userId':		_self.$mobLoginMHNo.val(),
					'password':	_self.$mobLoginMHPassword.val()
				};

				$.ajax({
					type: 'POST',
					url:'/bin/services/new/authuser',
					data: data,
					success: function(msg:string) {
						_self.redirectUser(msg);
						_self.$loginErrorValidation.show();
						var json = JSON.parse(msg);
						var responseCode = json.responseCode;
						if(responseCode == "OK") {
							console.log("success");
							var loginSuccess = $("#exceptionmsg").attr("data-loginsuccess");

							var d = new Date();
							d.setTime(d.getTime() + (30 * 60 * 1000));
							var expires = "expires="+d.toUTCString();

							//document.cookie="jade="+json.cookieValue+";"+expires+";path=/";
							document.cookie="phantom="+json.phantomCookieValue+";"+expires+";path=/";
							document.cookie = "userName=" + JSON.parse(json.phantomCookieValue).userName +";"+expires+";path=/";
							document.cookie = "milesCount=" + JSON.parse(json.phantomCookieValue).milesCount + ";"+expires+";path=/";
							document.cookie = "flyerID=" + JSON.parse(json.phantomCookieValue).flyerID + ";"+expires+";path=/"; 
							document.cookie = "memberStatus=" + JSON.parse(json.phantomCookieValue).memberStatus + ";"+expires+";path=/"; 
							// _self.bcommon.preloaderClose();
							_self.$ibeFormContainer.hide();
							_self.$ibeNav.find('li').removeClass('selected');
							window.location.href = loginSuccess;
            	// Redirect to the configured page from here.
            } else if(responseCode == "PW") {
            	_self.$loginErrorValidation.show();
            	_self.$mobLoginMHPassword.addClass('has-error');
            	_self.$mobLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 4 more attempt(s)";
            	_self.$loginError.push($checkInBookRefNoLastnameValidate);
            } else if(responseCode == "LC") {
            	_self.$loginErrorValidation.show();
            	var locked  = $("#exceptionmsg").attr("data-locked");
            	_self.$loginErrorValidation.show();
            	_self.$mobLoginMHNo.addClass('has-error');
            	_self.$mobLoginMHNo.parent().find('.booking-form--title').addClass('has-error');

            	_self.$loginError.push(locked);

            } else if(responseCode == "NA") {
            	_self.$loginErrorValidation.show();
            	_self.$mobLoginMHNo.addClass('has-error');
            	_self.$mobLoginMHNo.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoValidate = "Invalid login";
            	_self.$loginError.push($checkInBookRefNoValidate);
            } else if(responseCode == "W2") {
            	_self.$loginErrorValidation.show();
            	_self.$mobLoginMHPassword.addClass('has-error');
            	_self.$mobLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 3 more attempt(s)";
            	_self.$loginError.push($checkInBookRefNoLastnameValidate);
            } else if(responseCode == "W3") {
            	_self.$loginErrorValidation.show();
            	_self.$mobLoginMHPassword.addClass('has-error');
            	_self.$mobLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 2 more attempt(s)";
            	_self.$loginError.push($checkInBookRefNoLastnameValidate);
            } else if(responseCode == "W4") {
            	_self.$loginErrorValidation.show();
            	_self.$mobLoginMHPassword.addClass('has-error');
            	_self.$mobLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 1 more attempt(s)";
            	_self.$loginError.push($checkInBookRefNoLastnameValidate);
            } else if(responseCode == "ST") {
            	_self.$loginErrorValidation.show();
            	_self.$mobLoginMHPassword.addClass('has-error');
            	_self.$mobLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoLastnameValidate = "This is invalid/inactive account. Kindly contact call center for further information";
            	_self.$loginError.push($checkInBookRefNoLastnameValidate);
            }else if (responseCode == "TO") {
				_self.$loginErrorValidation.show();
				_self.$loginError.push("Sorry, we are unable to process your request at this time. please try again later.");
			}
            var $validationContainer = _self.$mobLoginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
            var $validationMessagelist = $validationContainer;
            for (var i = 0, len = _self.$loginError.length; i < len; i++) {
            	$validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
            }

            if (responseCode !== "OK") {
	              _self.bcommon.preloaderClose();
	            }
          },
          error: function(error:any) {
          	console.error(error);
          }
        });
			} else {
				console.log('Fail');
				_self.bcommon.preloaderClose();
				// _self.$ibeFormContainer.hide();
				_self.$ibeNav.find('li').removeClass('selected');
			}
		});
	}

	/**
	 * validation for midscreen login form
	 * - not currently used on site
	 * - is basically the same thing as mob form, but different ids
	 */
	midScreenValidation(): void {
		let _self = this;
		let $midScrLoginSubmitBtn: any = $('.midScrEnRichLoginSubmit');

		$midScrLoginSubmitBtn.click((evt:any) => {
			evt.preventDefault();

			_self.$loginError = [];
			_self.$loginErrorValidation.show();
			if ((_self.$midScrLoginMHNo.val() != '') && (_self.$midScrLoginMHPassword.val() != '')) {
				 _self.$loginErrorValidation.hide();
			}

			if (_self.$midScrLoginMHNo.val() == '') {
				let $midScrLoginMHNoValidate:any = _self.$midScrLoginMHNo.attr('data-loginmhno');
				_self.$loginError.push('<strong>'+_self.$midScrLoginMHNo.parent().find('label').text()+':</strong> '+$midScrLoginMHNoValidate);
				_self.$midScrLoginMHNo.addClass('has-error');
				_self.$midScrLoginMHNo.parent().find('.booking-form--title').addClass('has-error');
			} else {
				_self.$midScrLoginMHNo.removeClass('has-error');
				_self.$midScrLoginMHNo.parent().find('.booking-form--title').removeClass('has-error');
			}

			if (_self.$midScrLoginMHPassword.val() == '') {
				let $midScrLoginMHPasswordValidate:any = _self.$midScrLoginMHPassword.attr('data-loginmhpassword');
				_self.$loginError.push('<strong>'+_self.$midScrLoginMHPassword.parent().find('label').text()+':</strong> '+$midScrLoginMHPasswordValidate);
				_self.$midScrLoginMHPassword.addClass('has-error');
				_self.$midScrLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
			} else {
				_self.$midScrLoginMHPassword.removeClass('has-error');
				_self.$midScrLoginMHPassword.parent().find('.booking-form--title').removeClass('has-error');
			}
			let $validationContainer:any = _self.$midLoginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=_self.$loginError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + _self.$loginError[i] + '</li>');
			}

			if (_self.$midScrLoginMHNo.val() != '' && _self.$midScrLoginMHPassword.val() != '') {
				if ($('#ibe-midlogin--enrich').is(':checked')) {
					let $cookieIdValue: any = _self.$midScrLoginMHNo.val();
					Cookies.set(_self.$loginCookieName, $cookieIdValue);
				} else {
					Cookies.set(_self.$loginCookieName, '');
				}
				_self.bcommon.preloader();
				_self.$loginError = [];
				console.log('Success');
				var data = {
					'userId':		_self.$midScrLoginMHNo.val(),
					'password':	_self.$midScrLoginMHPassword.val()
				};

				$.ajax({
					type: 'POST',
					url:'/bin/services/new/authuser',
					data: data,
					success: function(msg:string) {
						_self.redirectUser(msg);
						_self.$loginErrorValidation.show();
						var json = JSON.parse(msg);
						var responseCode = json.responseCode;

						if (responseCode == "OK") {
							console.log("success");
							var loginSuccess = $("#exceptionmsg").attr("data-loginsuccess");

							var d = new Date();
							d.setTime(d.getTime() + (30 * 60 * 1000));
							var expires = "expires="+d.toUTCString();

							//document.cookie="jade="+json.cookieValue+";"+expires+";path=/";
							document.cookie="phantom="+json.phantomCookieValue+";"+expires+";path=/";
							document.cookie = "userName=" + JSON.parse(json.phantomCookieValue).userName +";"+expires+";path=/";
							document.cookie = "milesCount=" + JSON.parse(json.phantomCookieValue).milesCount + ";"+expires+";path=/";
							document.cookie = "flyerID=" + JSON.parse(json.phantomCookieValue).flyerID + ";"+expires+";path=/"; 
							document.cookie = "memberStatus=" + JSON.parse(json.phantomCookieValue).memberStatus + ";"+expires+";path=/"; 
							_self.bcommon.preloaderClose();
							_self.$ibeFormContainer.hide();
							_self.$ibeNav.find('li').removeClass('selected');
							window.location.href = loginSuccess;
            	// Redirect to the configured page from here.
            } else if(responseCode == "PW") {
            	_self.$loginErrorValidation.show();
            	_self.$midScrLoginMHPassword.addClass('has-error');
            	_self.$midScrLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 4 more attempt(s)";
            	_self.$loginError.push($checkInBookRefNoLastnameValidate);
            } else if(responseCode == "LC") {
            	_self.$loginErrorValidation.show();
            	var locked  = $("#exceptionmsg").attr("data-locked");
            	_self.$loginErrorValidation.show();
            	_self.$midScrLoginMHNo.addClass('has-error');
            	_self.$midScrLoginMHNo.parent().find('.booking-form--title').addClass('has-error');

            	_self.$loginError.push(locked);

            } else if(responseCode == "NA") {
            	_self.$loginErrorValidation.show();
            	_self.$midScrLoginMHNo.addClass('has-error');
            	_self.$midScrLoginMHNo.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoValidate = "Invalid login";
            	_self.$loginError.push($checkInBookRefNoValidate);
            } else if(responseCode == "W2") {
            	_self.$loginErrorValidation.show();
            	_self.$midScrLoginMHPassword.addClass('has-error');
            	_self.$midScrLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 3 more attempt(s)";
            	_self.$loginError.push($checkInBookRefNoLastnameValidate);
            } else if(responseCode == "W3") {
            	_self.$loginErrorValidation.show();
            	_self.$midScrLoginMHPassword.addClass('has-error');
            	_self.$midScrLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 2 more attempt(s)";
            	_self.$loginError.push($checkInBookRefNoLastnameValidate);
            } else if(responseCode == "W4") {
            	_self.$loginErrorValidation.show();
            	_self.$midScrLoginMHPassword.addClass('has-error');
            	_self.$midScrLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoLastnameValidate = "Invalid Password. You have 1 more attempt(s)";
            	_self.$loginError.push($checkInBookRefNoLastnameValidate);
            } else if(responseCode == "ST") {
            	_self.$loginErrorValidation.show();
            	_self.$midScrLoginMHPassword.addClass('has-error');
            	_self.$midScrLoginMHPassword.parent().find('.booking-form--title').addClass('has-error');
            	var $checkInBookRefNoLastnameValidate = "This is invalid/inactive account. Kindly contact call center for further information";
            	_self.$loginError.push($checkInBookRefNoLastnameValidate);
            }else if (responseCode == "TO") {
				_self.$loginErrorValidation.show();
				_self.$loginError.push("Sorry, we are unable to process your request at this time. please try again later.");
			}
            var $validationContainer = _self.$midLoginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
            var $validationMessagelist = $validationContainer;
            for (var i = 0, len = _self.$loginError.length; i < len; i++) {
            	$validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
            }

            if (responseCode !== "OK") {
	              _self.bcommon.preloaderClose();
	            }
          },
          error: function(error:any) {
          	_self.bcommon.preloaderClose();
          	_self.$ibeFormContainer.hide();
          	_self.$ibeNav.find('li').removeClass('selected');
          }
        });
			} else {
				console.log('Fail');
				_self.bcommon.preloaderClose();
				_self.$ibeFormContainer.hide();
				_self.$ibeNav.find('li').removeClass('selected');
			}
		});
	}

	isUserLoggedIn():boolean {
		let _self = this;
		let value = "; " + document.cookie;
		let parts = value.split("; " + "phantom" + "=");
		let sapphireToken =_self.getCookie("sapphire");
		var d = new Date();
		d.setTime(d.getTime() + (30 * 60 * 1000));
		var expires = "expires="+d.toUTCString();
		if(sapphireToken && sapphireToken!==undefined)
		{
			if (parts.length == 2) {
				let parts1 = parts.pop().split(";").shift();
				if(parts1) {
					if(parts1.includes("\\"))
					{
						parts1 = JSON.parse(parts1);
						document.cookie="phantom="+parts1+";"+expires+";path=/";
					}
					let userName = JSON.parse(parts1).firstName;
					$(".username").html(userName);
					let c002nav = new headerContent();
					let splitUserName = userName.split(" ");
					let firstNameChar = splitUserName[0].charAt(0);
					let lastNameChar = "";
					$(".enrich-login--success").attr("data-enrich-firstname",firstNameChar);
					$(".enrich-login--success").attr("data-enrich-lastname",lastNameChar);
					c002nav.enrichMember();
					return true;
				}
			}
			else{
				let studentId =_self.getCookie("studentEnrichId");
				let studentName =_self.getCookie("studentName");
				let athleteId=_self.getCookie("athleteEnrichId");
				let athleteName=_self.getCookie("athleteName");
				if(athleteId && athleteName){
					studentId=athleteId;
					studentName=athleteName;
				}
				if(studentId && studentName)
				{
					$(".username").html(studentName);
					let c002nav = new headerContent();
					let splitUserName = studentName.split(" ");
					let firstNameChar = splitUserName[0].charAt(0);
					let lastNameChar = "";
					$(".enrich-login--success").attr("data-enrich-firstname",firstNameChar);
					$(".enrich-login--success").attr("data-enrich-lastname",lastNameChar);
					c002nav.enrichMember();
					return true;
				}
	
				return false;
	
			}
		}
		
		return false;
	}

	getCookie(name:string): any {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		var cookieVal:any;
		if (parts.length == 2) {
			cookieVal = parts.pop().split(";").shift();
			return cookieVal;
		}
	}

	isSameUserLoggedIn(accessToken:string):boolean {
		let _self = this;
		let parts1 =_self.getCookie("phantom");
		//let cookieAccessToken = _self.getCookie("accessToken");
			if(parts1) {
				if(accessToken && accessToken!==undefined)
				{					
					let userName = JSON.parse(parts1).firstName;
					$(".username").html(userName);
					let c002nav = new headerContent();
					let splitUserName = userName.split(" ");
					let firstNameChar = splitUserName[0].charAt(0);
					let lastNameChar = "";
					$(".enrich-login--success").attr("data-enrich-firstname",firstNameChar);
					$(".enrich-login--success").attr("data-enrich-lastname",lastNameChar);
					c002nav.enrichMember();
					return true;
				}
				
			}
		
		return false;
	}

	clearUserDataOnLogout():void {
		//document.cookie = "jade=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "phantom=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "studentEnrichId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "studentDob=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "studentEmail=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "studentExpiryDate=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "studentId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "studentMemberSince=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "studentName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		//mhAthlete clear
		document.cookie = "athleteEnrichId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "athleteDob=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "athleteEmail=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "athleteExpiryDate=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "athleteId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "athleteMemberSince=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "athleteName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "category=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		//end MHathlet
		document.cookie = "milesCount=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "flyerID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "memberStatus=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		let cookieAccessToken = this.getCookie("sapphire");
		document.cookie = "sapphire="+cookieAccessToken+";domain=.malaysiaairlines.com;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "profileSessionEnabled=true; expires=Thu, 01 Jan 1970 00:00:01 GMT";
		document.cookie = "isSummaryLoaded=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		// clear flysiswa information
		document.cookie="isFlysiswaUser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie="voucherCode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

	}

	logOutUser():void {
		let _self = this;
		let redirectTo:string = $(".logoutLink").attr("data-redirectto");

		_self.clearUserDataOnLogout();

		if (redirectTo && redirectTo != "") {
			window.location.href = redirectTo;
		} else {
			location.reload();
		}
	}

	redirectUser(msg:string):void {
		if(msg.indexOf("timeout") > -1) {
			msg = msg.replace("timeout-","");
			window.location.href = msg;
		}
	}

	logoutHandler(): void {
		let _self = this;

    $(".logoutLink").on("click",function() {
    	// clearUserDataOnLogout();
    	// var redirectTo = $(this).attr("data-redirectto");
    	// if(redirectTo && redirectTo != "") {
    	// 	window.location.href = redirectTo;
    	// } else {
    	// 	location.reload();
    	// }
	  	_self.logOutUser();
    });
	}
	accordionMenu():void{
	
		     var accordionIndex:number =2;


		var Accordion = function(el:any, multiple:any) {
			this.el = el || {};
			this.multiple = multiple || false;

			// Variables privadas
			var links = this.el.find('.link');
			// var links2 = this.el.find('#webdesign');
		
			// Evento
			links.on('click', {
				el: this.el, 
				multiple: this.multiple
			}, this.dropdown)
			// links2.trigger("click");
		}
	
		Accordion.prototype.dropdown = function(e:any) {
			var $el = e.data.el;
				const $this = $(this),
				$next = $this.next();
			
			$next.slideToggle();
			$this.parent().toggleClass('open');
	
			if (!e.data.multiple) {
				$el.find('.submenu').not($next).slideUp().parent().removeClass('open');
			};
			e.stopPropagation(); // This is the preferred method.
			return false;  
		}	
	
		var accordion = new (Accordion as any)($('.logmenu-accordion'), false);
		
      
		
	}

}

let scope:Element = document.querySelector('#login-container');
if (scope){
	try {
		let loginform = new loginForm();
		$(document).ready(function(){
			loginform.nav();
			loginform.initLoginCookie();
			loginform.loginEnrich();
			loginform.logoutHandler();
			loginform.accordionMenu();
		});
	} catch(e) {console.error(e);}
}
